export interface EnvConfig {
    baseUrl: string;
    authIssuer: string;
    authClientId: string;
    logging?: boolean;
}

const envConfigs: Record<string, EnvConfig> = {
    dev: {
        baseUrl: "https://users.dev.dip.azure.corp.trumpf.com/mytui/servicebot-ext/middleware",
        authIssuer: "https://identity-s.trumpf.com",
        authClientId: "JvfYbwCW7dPLRwGgzLIV9keKZHMa",
        logging: true
    },
    qa: {
        baseUrl: "https://users.qa.dip.azure.corp.trumpf.com/mytui/servicebot-ext/middleware",
        authIssuer: "https://identity-s.trumpf.com",
        authClientId: "TfB597gdApidA9Nzb4jogZiyt0oa",
        logging: true
    },
    prod: {
        baseUrl: "https://users.prod.dip.azure.corp.trumpf.com/mytui/servicebot-ext/middleware",
        authIssuer: "https://identity.trumpf.com",
        authClientId: "cLQBJ_ZM8e8eSRk4goJdfevdyrwa"
    }
};
let env = "prod";

/**
 * get config for a specific environment
 * @param environment any custom env string (optional - will use env set by setEnv otherwise)
 * @returns config object
 */
export const getEnvConfig = (environment?: string): EnvConfig => {
    return envConfigs[environment || env];
};

/**
 * set the current environment (used for getEnvConfig)
 * @param environment any custom env string
 */
export const setEnv = (environment: string) => {
    if (!envConfigs[environment]) {
        console.error(`Environment ${environment} not found`);
        return;
    }
    env = environment;
};
